import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "projectSelectionWrapper container px-4 md:px-0 md:px-4 2xl:px-0" }
const _hoisted_2 = { class: "text-2xl md:text-3xl lg:mx-auto pt-4" }
const _hoisted_3 = { class: "text-2xl md:text-3xl lg:mx-auto" }
const _hoisted_4 = { class: "projectsList mt-16" }

import { useStore } from "@/composables/useTypedStore";
import { IonContent, IonPage, onIonViewWillEnter, useIonRouter } from '@ionic/vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
//Composables
import useUser from '@/composables/useUser';
//Components
import Toolbar from '@/components/Navigation/Toolbar.vue';
import ProjectCard from '@/components/v2/Project/ProjectCard.vue';
import useFetchData from '@/composables/useFetchData';
import BestandsaufnahmeModel from "@/models/ba/models/bestandsaufnahme.model";
import Immobilie from "@/models/immobilie.model";
//Variables

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSelection',
  setup(__props) {

const store = useStore()
const router = useIonRouter()
const { t } = useI18n({ useScope: 'global' })
const user = computed(() => useUser().user.value)
const useData = useFetchData();
//Vuex Mutations
const storeCurrentProject = (project: object) => store.commit('user/storeCurrentUserProject', project)
const currentProject = computed(() => store.state.user.currentUserProject);

//Lifecycle Methods
onIonViewWillEnter(() => {
  store.commit("app/showBottomNavigation");
});

//Methods
async function handleProjectSelection(project: any) {
  const oldProjectId = currentProject.value.id;
  await storeCurrentProject(project);

  if ( oldProjectId !== project.id ) {
    await BestandsaufnahmeModel.dispatch('$deleteAllFromLocal');
    await Immobilie.dispatch('$deleteAllFromLocal');
  }

  useData.doRefresh();
  store.commit("app/incrementAppMapUpdateCounter");
  router.navigate('/', 'forward', 'pop')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "projectSelectionPage" }, {
    default: _withCtx(() => [
      _createVNode(Toolbar, {
        title: _unref(t)('userProject.chooseProject')
      }, null, 8, ["title"]),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(user.value?.organisation.name), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('userProject.chooseProject')), 1),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value?.organisation.projects, (item) => {
                return (_openBlock(), _createBlock(ProjectCard, {
                  key: item.id,
                  project: item,
                  onClick: ($event: any) => (handleProjectSelection(item))
                }, null, 8, ["project", "onClick"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})